import Vue from 'vue'
import Vuex from 'vuex'
import material from './modules/material'
import materialTypes from './modules/materialTypes'
import steps from './modules/steps'
import ui from './modules/ui'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    material,
    materialTypes,
    steps,
    ui
  }
})
